import './modules/scrollTop';
import './modules/map';
import './modules/swiper';
import './modules/pageloader';
import './modules/script';
import './modules/photoswipe';
import './modules/inViewport';
import './modules/ieparallaxbugfix';



// WEBPACK FOOTER //
// ./assets/js/src/index.js